import * as React from "react";
import HeroImage from "../assets/headers/rigCompressed.jpg";
import LargeHeroArea from "../components/shared/BasePage/LargeHeroArea";
import { Container, Link } from "@material-ui/core";
import BasePageStyles from "../components/shared/Styling/BasePageStyling";
import TracercoButton from "../components/shared/TracercoButton";

const LoginPage: React.FC = () => {
    const classes = BasePageStyles();

    return (
        <main className={classes.main}>
            <LargeHeroArea
                imageUri={HeroImage}
                title="Welcome"
                subtitle="It looks like you haven't been assigned any projects yet.
                You can use the buttons below to contact us and get help."
            >
                <div style={{ display: "inline-flex", marginTop: "32px" }}>
                    <Link
                        color="inherit"
                        href="mailto:tracerco@tracerco.com"
                        style={{ textDecoration: "none" }}
                    >
                        <TracercoButton style={{ padding: "24px" }}>
                            Email Tracerco
                        </TracercoButton>
                    </Link>
                    <Link
                        color="inherit"
                        href="https://www.tracerco.com/contact-us/"
                        style={{ textDecoration: "none" }}
                    >
                        <TracercoButton
                            style={{ marginLeft: "32px", padding: "24px" }}
                        >
                            Contact Page
                        </TracercoButton>
                    </Link>
                </div>
            </LargeHeroArea>
            <Container
                component="section"
                className={classes.mainContent}
                maxWidth="lg"
            ></Container>
        </main>
    );
};

export default LoginPage;
